import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CartPricingTierPage } from 'src/app/modals/cart-pricing-tier/cart-pricing-tier.page';

const routes: Routes = [
  {
    path: '',
    component: CartPricingTierPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CartPricingTierPage]
})
export class CartPricingTierPageModule {}
